import { Model } from '@vuex-orm/core'
export default class Language extends Model {
  static entity = 'language'
  constructor (lng) {
    super(lng)
    this.language = lng
  }

  static fields () {
    return {
      language: this.attr(''),
      text: this.attr('')
    }
  }

  static apiConfig = {}
}